import type { HTMLAttributes, ReactNode } from "react";

type CardPadding = "none" | "sm" | "md" | "lg";
type CardTone = "default" | "purple";

interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: "div" | "section";
  padding?: CardPadding;
  tone?: CardTone;
  interactive?: boolean;
  children: ReactNode;
}

export function Card({ as: Component = "div", padding, tone = "default", interactive = false, className = "", children, ...props }: CardProps) {
  const paddingClass = padding ? `mmm-card--padding-${padding}` : "";
  const toneClass = tone === "default" ? "" : `mmm-card--tone-${tone}`;
  return (
    <Component className={`mmm-card ${paddingClass} ${toneClass} ${interactive ? "mmm-card--interactive" : ""} ${className}`.trim()} {...props}>
      {children}
    </Component>
  );
}
